import { get } from 'lodash';
import { FEATURE_NAME, PERMISSION_NAME } from 'utils/constants';
import { FEATURE_LEVEL_USER_ROLE_MAPPING } from './featureAndRolePermissions';
import { isUserHasAdminRoles } from 'utils/userRolesHelper';

export const hasSomePermissionsOnFeature = (user, locationId, featureName, permissionNames) => {
    const featurePermissions = get(user, `userLocationFeature.${locationId}.${featureName}`, []);
    return permissionNames.some((perm) => featurePermissions.includes(perm));
};

export const hasReadPermissionOnFeature = (user, locationId, featureName) => {
    return hasSomePermissionsOnFeature(user, locationId, featureName, [PERMISSION_NAME.VIEW, PERMISSION_NAME.FULL_ACCESS]);
};

export const hasCreatePermissionOnFeature = (user, locationId, featureName) => {
    return hasSomePermissionsOnFeature(user, locationId, featureName, [PERMISSION_NAME.FULL_ACCESS]);
};

export const hasEditPermissionOnFeature = (user, locationId, featureName) => {
    return hasSomePermissionsOnFeature(user, locationId, featureName, [PERMISSION_NAME.FULL_ACCESS]);
};

export const hasDeletePermissionOnFeature = (user, locationId, featureName) => {
    return hasSomePermissionsOnFeature(user, locationId, featureName, [PERMISSION_NAME.FULL_ACCESS]);
};

export const hasAtLeastPermissionForFeature = (user, featureName, features = [], permissionNames) => {
    const userFeaturePermissions = Object.values(get(user, 'userLocationFeature', {}));
    const hasPermission = userFeaturePermissions.some((userFeaturePermission) => {
        const featurePermissions = get(userFeaturePermission, featureName, []);
        if (featurePermissions.length) {
            return permissionNames.some((perm) => featurePermissions.includes(perm));
        }
        return false;
    });

    const featureLevelThatUserHasAccessOn = user?.roles?.map((role) => FEATURE_LEVEL_USER_ROLE_MAPPING[role]).flat();
    const featuresLevelForFeatureName = features?.find((feature) => feature.name === featureName)?.level;
    return hasPermission && featureLevelThatUserHasAccessOn.includes(featuresLevelForFeatureName);
};

export const hasAtLeastReadPermissionForFeature = (user, featureName, features) => {
    return hasAtLeastPermissionForFeature(user, featureName, features, [PERMISSION_NAME.VIEW]);
};

export const hasAtLeastFullAccessPermissionForFeature = (user, featureName, features) => {
    return hasAtLeastPermissionForFeature(user, featureName, features, [PERMISSION_NAME.FULL_ACCESS]);
};

export const canUserGrantPermissionForOthersInLocation = (user, locationId) => {
    return (
        isUserHasAdminRoles(user) || hasSomePermissionsOnFeature(user, locationId, FEATURE_NAME.USER_AND_PERMISSION, [PERMISSION_NAME.FULL_ACCESS])
    );
};

export const canUserGrantPermissionForFeature = (user, locationId, featureName, permissionName) => {
    return isUserHasAdminRoles(user) || hasSomePermissionsOnFeature(user, locationId, featureName, [permissionName, PERMISSION_NAME.FULL_ACCESS]);
};
